import React, { useEffect, useState , useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { ReactComponent as DownArrow } from '../assets/svgs/down-arrow.svg'; // Import your down arrow SVG icon
import { ReactComponent as MenuIcon } from '../assets/svgs/filters-map-menu.svg'; // Import the SVG icon


const MainContainer = styled.div`
  background: #385963;
  padding: 30px;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 320px;
  color: white;
  margin-top: 80px;
  margin-left: 20px;
  gap: 20px;

  /* Desktop (1024px and above) */
  @media (min-width: 1025px) {
    height: 60vh; /* Full height on desktop */
  }

  /* Tablet (768px to 1024px) */
  @media (max-width: 1024px) and (min-width: 768px) {
    height: 80vh; /* Adjust height for tablets */
  }

  /* Mobile (up to 768px) */
  @media (max-width: 768px) {
    height: 40vh; /* Adjust height for mobile */
  }
`;


const FiltersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  flex-grow: 1; /* This makes it take the full height available in MainContainer */

  /* Media queries for responsiveness */
  @media (max-width: 1024px) {
    max-height: 400px;
  }

  @media (max-width: 768px) {
    max-height: 300px;
  }

  @media (max-width: 480px) {
    max-height: 250px;
  }

  /* Custom scrollbar styling */
  ::-webkit-scrollbar {
    width: 12px;
    margin-left: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #91abb3;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-track {
    background: #f5f5f5;
    border-radius: 10px;
  }
`;

const Filter = styled.div`
  margin-top: 20px;
  :first-of-type {
    margin: 0;
  }
   h4{
     margin-bottom: 10px; 
     color:white;
     font-size: 20px;
  }
`;

const Label = styled.label`
  display: flex; 
  align-items: center; 
  gap: 10px; 
  font-size: 14px;
  margin-bottom: 10px;
  color: white;
  // font-weight: 800px;
  &:hover {
    color:white; 
     transition: all 0.4s;
     font-weight: 500;
  }
`;

const Checkbox = styled.input`
  appearance: none; 
  width: 18px; 
  height: 18px; 
  background-color:  #385963;
  border: 2px solid #ccc; 
  border-radius: 3px;
  cursor: pointer; 

  &:checked {
    background-color:  white; 
    border-color:  white; 
  }

  // &:checked::before {
  //   content: ''; /* Create a checkmark */
  //   position: absolute;
  //   top: 2px; /* Position checkmark */
  //   left: 5px; /* Position checkmark */
  //   width: 5px; /* Width of checkmark */
  //   height: 10px; /* Height of checkmark */
  //   border: solid  #6895e3; /* Color of checkmark */
  //   border-width: 0 2px 2px 0; /* Create the checkmark shape */
  //   transform: rotate(45deg); /* Rotate to create checkmark */
  // }
`;


const MenuButton = styled.button`
  position: absolute;
  top: 10px; 
  left: 20px; 
  padding: 12px 12px;
  background:  #385963;
  border-radius: 50px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
  color: white;
  border: none;
  cursor: pointer;

    svg {
    width: 28px; 
    height: 28px;
    fill: white; 
  }

  @media (max-width: 768px) {
   top: 10px;
   left: 20px; 
  }

  @media (max-width: 600px) {
   top: -4px; 
   left: 10px; 
  }
`;


const OverlayContainer = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const FilterButtons = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-top: 10px;
`;

const ClosePanelButton = styled.button`
    flex: 1;
    padding: 8px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    color: white;
    background-color: #f44336;

    &:hover {
        background-color: #d32f2f;
    }
`;

const ApplyButton = styled.button`
    flex: 1;
    padding: 8px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    color: white;
    background-color: #4caf50;

    &:hover {
        background-color: #388e3c;
    }
`;

function FilterButton({ onFilterChange }) {

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
    const [destinationCategories, setDestinationCategories] = useState([]);
    const [amenityCategories, setAmenityCategories] = useState([]);
    const [tempSelectedCategories, setTempSelectedCategories] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    // const [panelOpen, setPanelOpen] = useState(false);
    const [loadingDestinations, setLoadingDestinations] = useState(true);
    const [loadingAmenities, setLoadingAmenities] = useState(true);
    const [loggedIn, setLoggedIn] = useState(sessionStorage.getItem('loggedIn') === 'true');
    const [experienceCategories, setExperienceCategories] = useState([]);
    const [loadingExperiences, setLoadingExperiences] = useState(true);

    const [showMenu, setShowMenu] = useState(false);
    const [showFavorites, setShowFavorites] = useState(false);
    const [activeCategory, setActiveCategory] = useState(null);
    const menuRef = useRef(null);
    const favoritesRef = useRef(null);
    const menuButtonRef = useRef(null);
    const favoritesButtonRef = useRef(null);
  
    const toggleMenu = () => setShowMenu(!showMenu);
    const toggleFavorite = () => setShowFavorites(!showFavorites);
    const handleCategoryClick = (category) => {
      setActiveCategory(activeCategory === category ? null : category);
    };

    
    useEffect(() => {
      function handleClickOutside(event) {
          if (
              menuRef.current && 
              !menuRef.current.contains(event.target) && 
              !menuButtonRef.current.contains(event.target)
          ) {
              setShowMenu(false);
          };

          if (
              favoritesRef.current &&
              !favoritesRef.current.contains(event.target) &&
              !favoritesButtonRef.current.contains(event.target)
          ) {
              setShowFavorites(false);
          };
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
          document.removeEventListener("mousedown", handleClickOutside);
      };
  }, []);

    const selectedLanguage = sessionStorage.getItem('selectedLanguage') || 'en';
    const navigate = useNavigate();

    useEffect(() => {
      const fetchDestinationCategories = async () => {
        try {
          const response = await fetch(`${BASE_URL}DestinationCategory`);
          const data = await response.json();
          setDestinationCategories(data);
          setLoadingDestinations(false);
        } catch (error) {
          console.error('Error fetching destination categories:', error);
          setLoadingDestinations(false);
        }
      };
  
      fetchDestinationCategories();
  
      // Watch for changes to localStorage for loggedIn status
      const handleStorageChange = () => {
        setLoggedIn(sessionStorage.getItem('loggedIn') === 'true');
      };
  
      window.addEventListener('storage', handleStorageChange);
  
      return () => {
        window.removeEventListener('storage', handleStorageChange);
      };
    }, []);

    useEffect(() => {
      const fetchAmenitiesCategories = async () => {
        try {
          const response = await fetch(`${BASE_URL}AmenityCategory`);
          const data = await response.json();
          setAmenityCategories(data);
          setLoadingAmenities(false);
        } catch (error) {
          console.error('Error fetching amenities categories:', error);
          setLoadingAmenities(false);
        }
      };
  
      fetchAmenitiesCategories();
  
      // Watch for changes to localStorage for loggedIn status
      const handleStorageChange = () => {
        setLoggedIn(sessionStorage.getItem('loggedIn') === 'true');
      };
  
      window.addEventListener('storage', handleStorageChange);
  
      return () => {
        window.removeEventListener('storage', handleStorageChange);
      };
    }, []);
  

    useEffect(() => {
      const fetchExperiencesCategories = async () => {
        try {
          const response = await fetch(`${BASE_URL}ExperienceCategory`);
          const data = await response.json();
          setExperienceCategories(data);
          setLoadingExperiences(false);
        } catch (error) {
          console.error('Error fetching amenities categories:', error);
          setLoadingExperiences(false);
        }
      };
  
      fetchExperiencesCategories();
  
      // Watch for changes to localStorage for loggedIn status
      const handleStorageChange = () => {
        setLoggedIn(sessionStorage.getItem('loggedIn') === 'true');
      };
  
      window.addEventListener('storage', handleStorageChange);
  
      return () => {
        window.removeEventListener('storage', handleStorageChange);
      };
    }, []);

  const handleCategoryChange = (categoryId) => {
    const updatedTempCategories = tempSelectedCategories.includes(categoryId)
      ? tempSelectedCategories.filter((id) => id !== categoryId)
      : [...tempSelectedCategories, categoryId];

    setTempSelectedCategories(updatedTempCategories);
  };

  const applyFilters = () => {
    setSelectedCategories(tempSelectedCategories);
    onFilterChange(tempSelectedCategories);
  };

  const handleViewPlanClick = () => {
    navigate('/planView');
  };

    const clearFilters = () =>{
      setTempSelectedCategories([]);
      setSelectedCategories([]);
      onFilterChange([]);
    };

    return (
      <OverlayContainer>
        {/* // <FilterButtonContainer> */}
            {/* <FilterButtonStyled
                onClick={() => {
                    setPanelOpen(!panelOpen);
                    setTempSelectedCategories(selectedCategories);
                }}
            >
                ⚙️ Φίλτρα
            </FilterButtonStyled> */}
             <MenuButton ref={menuButtonRef} onClick={toggleMenu}>
               <MenuIcon /> 
             </MenuButton>

            {/* {!loggedIn && (
                <ViewPlanButton
                    onClick={handleViewPlanClick}
                >
                    Προβολή Πλάνου
                </ViewPlanButton>
            )} */}

            {showMenu && (
              <MainContainer ref={menuRef}>
                <FiltersContainer >
                    <Filter>
                        <h4>{i18n.t('destinationsCategories')}</h4>
                        {loadingDestinations ? (
                            <p>Loading destination categories...</p>
                        ) : (
                            <>
                                {destinationCategories.map((category) => (
                                    <Label key={category.id}>
                                        <Checkbox
                                            type="checkbox"
                                            id={`destination-${category.id}`}
                                            checked={tempSelectedCategories.includes(category.id)}
                                            onChange={() => handleCategoryChange(category.id)}
                                        />
                                        {category.name[selectedLanguage]}
                                        {/* <p>{category.description[selectedLanguage]}</p> */}

                                        {/* <label htmlFor={`destination-${category.category_id}`}>{category.name}</label> */}
                                    </Label>
                                ))}
                            </>
                        )}
                   </Filter>

                   <Filter>
                        <h4>{i18n.t('amenitiesCategories')}</h4>
                        {loadingAmenities ? (
                            <p>Loading amenity categories...</p>
                        ) : (
                           <>
                                {amenityCategories.map((category) => (
                                    <Label key={category.id}>
                                        <Checkbox
                                            type="checkbox"
                                            id={`destination-${category.id}`}
                                            checked={tempSelectedCategories.includes(category.id)}
                                            onChange={() => handleCategoryChange(category.id)}
                                        />
                                        {category.name[selectedLanguage]}
                                        {/* <p>{category.description[selectedLanguage]}</p> */}

                                        {/* <label htmlFor={`destination-${category.category_id}`}>{category.name}</label> */}
                                    </Label>
                                ))}
                            </>
                        )}
                   </Filter>

                   <Filter>
                        <h4>{i18n.t('experiencesCategories')}</h4>
                        {loadingExperiences ? (
                            <p>Loading experience categories...</p>
                        ) : (
                           <>
                                {experienceCategories.map((category) => (
                                    <Label key={category.id}>
                                        <Checkbox
                                            type="checkbox"
                                            id={`destination-${category.id}`}
                                            checked={tempSelectedCategories.includes(category.id)}
                                            onChange={() => handleCategoryChange(category.id)}
                                        />
                                        {category.name[selectedLanguage]}
                                        {/* <p>{category.description[selectedLanguage]}</p> */}

                                        {/* <label htmlFor={`destination-${category.category_id}`}>{category.name}</label> */}
                                    </Label>
                                ))}
                            </>
                        )}
                   </Filter>

                   </FiltersContainer>
                    <FilterButtons>
                        <ClosePanelButton onClick={clearFilters}>
                          {i18n.t('clear')}
                        </ClosePanelButton>
                        <ApplyButton onClick={applyFilters}>
                          {i18n.t('apply')}
                        </ApplyButton>
                    </FilterButtons>
              </MainContainer>
            )}
        </OverlayContainer>
    );
}




export default FilterButton;
